import axios from "axios";
import { isTokenExpired, clearToken } from "./auth";

/**
 * Setup axios interceptor to check token expiration on API calls
 */
export const setupAxiosInterceptor = (onTokenExpired: () => void) => {
  // Request interceptor - check token before making request
  axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token");
      
      if (token && isTokenExpired(token)) {
        // Token is expired, clear it and trigger logout
        clearToken();
        onTokenExpired();
        return Promise.reject(new Error("Token expired"));
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor - handle 401 unauthorized responses
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response?.status === 401) {
        // Token is invalid or expired on server side
        clearToken();
        onTokenExpired();
      }
      return Promise.reject(error);
    }
  );
};

